/* eslint-disable consistent-return */
import React, { useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import alert from 'react-s-alert';
import _ from 'lodash';
import { customStyle } from 'helper';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import PropTypes from 'prop-types';
import ViolationsContext from './ViolationsContext';
import * as actions from '../action';
import * as c from '../constant';

function ViolationsList({
  matrixList,
  getSelectedViolation,
  selectedViolation,
  getViolationsMatrixList,
  setFormData,
  formData,
  clearSelectedViolation,
  fetching,
}) {
  const { violations, setViolations } = useContext(ViolationsContext);

  const { register, handleSubmit } = useForm();

  useEffect(() => {
    getViolationsMatrixList();
  }, []);

  useEffect(() => {
    register({ name: 'reactSelect', required: true });
  });

  const handleAddViolation = () => {
    const { violation_code } = formData;
    if (violation_code) {
      ConfirmAlert(
        'Are you sure, you want to add?',
        () => {
          setViolations((prevViolations) => [
            ...prevViolations,
            {
              violation_code,
              fine_amount: _.get(selectedViolation, 'attributes.fine') || 0,
              particulars:
                _.get(selectedViolation, 'attributes.particular') || 'None',
            },
          ]);
          setFormData({
            violation_code: '',
            fine_amount: '',
            particulars: '',
            selectedViolation: '',
          });
          clearSelectedViolation();
        },
        () => {},
        {
          yesLabel: 'Confirm',
          noLabel: 'Cancel',
        }
      );
    } else {
      alert.error('Violation Code is required');
    }
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    setViolations(
      violations.filter((x) => x.violation_code !== data.violation_code)
    );
  };

  const RenderViolations = () => {
    return violations.map((data) => (
      <tr key={data.violation_code}>
        <th scope="row">{data.violation_code}</th>
        <td>{data.particulars || data.particular}</td>
        <td className="text-right">{data.fine_amount || data.amount}</td>
        <td className="text-center">
          <button
            type="button"
            className="btn-blank"
            onClick={handleRemove(data)}
          >
            <i className="far fa-trash-alt icon-delete" />
          </button>
        </td>
      </tr>
    ));
  };

  const handleDropDownChange = (key) => (e) => {
    if (key === 'violation_code') {
      getSelectedViolation(e.id);
    }
    if (key === 'apprehending_officer_id') {
      setFormData({
        ...formData,
        apprehending_officer: e.label,
        [key]: e ? e.value : '',
      });
      return false;
    }
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const createDropdownMatrix = (list) => {
    const newList = [];

    list.map((data) => {
      newList.push({
        label: `${data.attributes.violation_code} - ${data.attributes.particular}`,
        value: data.attributes.violation_code,
        id: data.id,
      });

      return true;
    });

    return newList;
  };

  const computeTotalFine = (data) => {
    if (data.length > 0) {
      const sums = [];
      data.map((e) => {
        if (e.fine_amount === undefined) {
          const val = e.amount.toString() || '';
          return sums.push(parseFloat(val.replace(/,/g, '')));
        }
        return sums.push(
          parseFloat(e.fine_amount.toString().replace(/,/g, ''))
        );
      });
      return _.sum(sums);
    }
  };

  const filterViolationCodes = (data) => {
    const selectedViolationList = [];
    violations.map((e) => {
      return selectedViolationList.push(e.violation_code.toString());
    });

    const filtered = _.filter(
      data,
      (v) => !_.includes(selectedViolationList, v.value)
    );

    return filtered;
  };

  return (
    <div>
      {/* <div
        style={{
          fontSize: '11px',
          color: 'grey',
          marginTop: '20px',
          marginBottom: '10px',
        }}
      >
        You can add multiple violations
      </div> */}
      <label className="text-primary font-weight-bold">Add Violations</label>
      <div className="row pb-3">
        <div className="col-3 pt-1">
          <div className="form-label pb-2"> Violation Code: </div>
          <div>
            <Select
              name="reactSelect"
              required
              options={filterViolationCodes(createDropdownMatrix(matrixList))}
              styles={customStyle}
              placeholder="Select Violation Code"
              value={{
                label: _.get(formData, 'violation_code') || '',
                value: _.get(formData, 'violation_code') || '',
              }}
              onChange={handleDropDownChange('violation_code')}
            />
          </div>
        </div>
        <div className="col-2 pt-1 form-group">
          <div className="form-label pb-1"> Fine Amount:</div>
          <input
            disabled
            type="text"
            className="form-control"
            value={
              _.get(formData, 'violation_code')
                ? _.get(selectedViolation, 'attributes.fine') || ''
                : ''
            }
          />
        </div>
        <div className="col-5 pt-1 form-group">
          <div className="form-label pb-1"> Particulars:</div>
          <input
            disabled
            type="text"
            className="form-control"
            value={
              _.get(formData, 'violation_code')
                ? _.get(selectedViolation, 'attributes.particular') || ''
                : ''
            }
          />
        </div>
        <div className="col-2 pt-1 my-4">
          <button
            disabled={fetching}
            type="button"
            onClick={handleSubmit(handleAddViolation)}
            className="btn btn-primary gen-btn cms-bg-color-primary cms-outline-primary my-0"
          >
            <span className="font-weight-bold">
              {fetching ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                <>
                  <i className="fas fa-plus" />
                  &nbsp;&nbsp; Add Violation
                </>
              )}
            </span>
          </button>
        </div>
      </div>
      <div className="row mt-2 mx-auto">
        <table className="table table-bordered  p-2">
          <thead>
            <tr>
              <th className="text-center" scope="col">
                Code
              </th>
              <th className="text-center" scope="col">
                Particulars
              </th>
              <th className="text-center" scope="col">
                Amount
              </th>
              <th className="text-center" scope="col">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <RenderViolations />
            <tr className="cms-bg-color-primary-light cms-text-primary">
              <td>&nbsp;</td>
              <td className="text-right font-weight-bold">
                Total Fine Amount:{' '}
              </td>
              <td className="text-right">
                <span className="ml-3 text-primary font-weight-bold">
                  {computeTotalFine(violations) &&
                    computeTotalFine(violations).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })}
                </span>
              </td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
        {/* <div className="row d-flex justify-content-end w-100">
          <div className="col-8">Total Fine Amount: </div>
          <div className="col-4">
            <span className="ml-3 text-primary font-weight-bold">
              {computeTotalFine(violations) &&
                computeTotalFine(violations).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })}
            </span>
          </div>
        </div> */}
      </div>
    </div>
  );
}

ViolationsList.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  getSelectedViolation: PropTypes.instanceOf(Function).isRequired,
  selectedViolation: PropTypes.instanceOf(Object).isRequired,
  matrixList: PropTypes.instanceOf(Array).isRequired,
  getViolationsMatrixList: PropTypes.instanceOf(Function).isRequired,
  fetching: PropTypes.bool.isRequired,
  clearSelectedViolation: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  matrixList: _.get(api, `${c.GET_VIOLATION_MATRIX_LIST}.list`) || [],
  selectedViolation: _.get(api, `${c.GET_MATRIX_INFO}.item`) || {},
  municipalityListApp: _.get(api, `${c.GET_APP_MUNICIPALITIES}.list`) || [],
  barangayListApp: _.get(api, `${c.GET_APP_BARANGAYS}.list`) || [],
  fetching: api.loading.indexOf(c.GET_MATRIX_INFO) > -1,
});

const enhance = _.flowRight([
  withForm,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViolationsList);
